import React, { useEffect, useState } from "react";
import {
  DocumentData,
  QueryDocumentSnapshot,
  QuerySnapshot,
  collection,
  deleteField,
  getDocs,
  getFirestore,
  onSnapshot,
  orderBy,
  query,
  updateDoc,
  where,
} from "firebase/firestore";

import SharedDataInformation from "./SharedDataInformation";
import { app, auth } from "../lib/firebase";
import "../lib/RequireUser/index.css";

import { NewProjectExperimentType } from "../Types/projectExperiment";
import { object } from "firebase-functions/v1/storage";
import { error } from "console";

function SharedDataExperiment() {
  const db = getFirestore(app);

  const [prjExperiments, setPrjExperiments] = useState<
    NewProjectExperimentType[]
  >([]);

  const [pjExperiments, setPjExperiments] = useState<
    NewProjectExperimentType[]
  >([]);
  var addedDocument: boolean = false;

  const tempUser = localStorage.getItem("userUID");
  const displayValue = localStorage.getItem("displayValue");

  console.log(" displayValue = ", displayValue);

  const prjTitle = localStorage.getItem("projectTitle");
  console.log(" projectTitle = ", prjTitle);
  const todayDate: string = DateToYYYYMMDD(new Date());

  const q = query(
    collection(db, "projectExperiments"),
    where("projectTitle", "==", prjTitle),
    orderBy("experimentDate", "desc")
  );

  useEffect(
    () =>
      onSnapshot(q, (snapshot) => {
        return setPrjExperiments(
          snapshot.docs.map((doc) => {
            console.log("doc.data() = ", doc.data());
            return {
              id: doc.id,
              ...doc.data(),
            };
          })
        );
      }),
    []
  );

  let expNum = String(prjExperiments.length);
  localStorage.setItem("expNum", expNum);
  console.log("expNum = ", expNum);

  for (let i = 0; i < prjExperiments.length; i++) {
    if (prjExperiments[i].signatureRequested === "no") {
      prjExperiments[i].requestSignature = "Reqest";
      prjExperiments[i].requestButtonDisabled = false;
    } else {
      prjExperiments[i].requestSignature = "Reqested";
      prjExperiments[i].requestButtonDisabled = true;
    }
  }

  //Here we need to eliminate all of the experiments that don't have experiment data
  //but only if the displayValue = "Small"...note that there may be multiple
  //such experiments and currently we are only getting one experiment with data per project
  //Also, there is no check being done on "Large" which ensures that there is, in fact, data
  //Note that we enter this code with only one project and we need to go through all experiments
  //for that project regardless

  //So, actually we need 2 loops:
  //Loop 1 we look to see if there is any data at all and we count the experiemtnts
  //Loop 2 loops for the number of data experiment counts
  // If there is any data and the displayValue is large then we copy all the experiments to pj
  // and we are done
  // If the displayValue is small then we go through the experiments one at a time find the
  // data, copy to pj and decrement count
  // When count == 0 we are done

  //if (displayValue === "Small") {
  let tempShareable = "";

  //For each experiment
  let addCount = 0;
  //Loop1 - count the experiments sharing data
  for (let j = 0; j < prjExperiments.length; j++) {
    //Check to see if there is any data at all and if not continue with next experiment
    if (prjExperiments[j].experimentData !== undefined) {
      console.log(
        "prjExperiments[j].experimentData.length = ",
        prjExperiments[j].experimentData.length
      );
      //Loop through the experimentData entries
      let addExperiment = true;
      for (
        let k = 0;
        k < prjExperiments[j].experimentData.length && addExperiment;
        k++
      ) {
        if (prjExperiments[j].experimentData[k] !== undefined) {
          //Loop through the experimentData entries
          for (const [key, value] of Object.entries(
            prjExperiments[j].experimentData[k]
          )) {
            //If the key is dataShareable
            if (key === "dataShareable") {
              tempShareable = value;
              console.log("dataShareable = ", tempShareable);
              //If dataShareable === "Yes" or "With Consent"
              if (tempShareable === "Yes" || tempShareable === "With Consent") {
                addCount++;
                //Now, we need to continue with further experiments for the same project
                addExperiment = false;
              }
            }
          }
        }
      }
    }
  }
  //Loop 2 loops for the number of data experiment counts
  // If there is any data and the displayValue is large then we copy all the experiments to pj
  // and we are done
  // If the displayValue is small then we go through the experiments one at a time find the
  // data, copy to pj and decrement count
  // When count == 0 we are done
  let l = 0;
  let addBreak = true;
  for (let j = 0; j < prjExperiments.length && addCount != 0; j++) {
    if (displayValue == "Large") {
      for (let m = 0; m < prjExperiments.length; m++) {
        pjExperiments[m] = prjExperiments[m];
        console.log("else and pjExperiment = ", pjExperiments[m]);
        addCount = 0; //stop because we are copying all experiments for this one and only project
      }
    } else {
      //We only pick the experiments with data, copy the experiment, and decrement count
      //and we break when we have copied any experiment else we redundantly add the
      //same experiment multiple times if there is more than 1 data per experiment
      console.log("addCount 1 = ", addCount);
      console.log("addBreak 1 = ", addBreak);
      console.log("j 1 = ", j);
      if (prjExperiments[j].experimentData !== undefined) {
        console.log(
          "prjExperiments[j].experimentData.length = ",
          prjExperiments[j].experimentData.length
        );
        //Loop through the experimentData entries
        addBreak = true;
        for (
          let k = 0;
          k < prjExperiments[j].experimentData.length && addBreak;
          k++
        ) {
          console.log("addCount 2 = ", addCount);
          console.log("addBreak 2 = ", addBreak);
          console.log("j 2 = ", j);
          if (prjExperiments[j].experimentData[k] !== undefined) {
            //Loop through the experimentData entries
            for (const [key, value] of Object.entries(
              prjExperiments[j].experimentData[k]
            )) {
              //If the key is dataShareable
              if (key === "dataShareable") {
                tempShareable = value;
                console.log("dataShareable = ", tempShareable);
                //If dataShareable === "Yes" or "With Consent"
                if (
                  tempShareable === "Yes" ||
                  tempShareable === "With Consent"
                ) {
                  //Add this experiment to new array and break for next experiment
                  //console.log("added pjExperiment = ", pjExperiments[l]);
                  pjExperiments[l] = prjExperiments[j];
                  l++;
                  addCount--;
                  addBreak = false;
                  console.log("addCount 3 = ", addCount);
                  console.log("addBreak 3 = ", addBreak);
                  console.log("j 3 = ", j);
                  //Now, we need to continue with further experiments for the same project
                }
              }
            }
          }
        }
      }
    }
  }

  //} else {
  //  for (let m = 0; m < prjExperiments.length; m++) {
  //    pjExperiments[m] = prjExperiments[m];
  //    console.log("else and pjExperiment = ", pjExperiments[m]);
  //  }

  return (
    <div>
      {pjExperiments && pjExperiments.length ? (
        <div>
          {pjExperiments?.map((pjExperiments) => (
            <SharedDataInformation
              key={pjExperiments.id}
              projectExperiment={pjExperiments}
            />
          ))}
        </div>
      ) : (
        <p>Loading...</p>
      )}
    </div>
  );

  function DateToYYYYMMDD(date: Date) {
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let monthString = month.toString();
    if (month < 10) {
      monthString = "0" + monthString;
    }
    let day = date.getDate();
    let dayString = day.toString();
    if (day < 10) {
      dayString = "0" + dayString;
    }
    let dateString = `${year}/` + monthString + "/" + dayString;
    return dateString;
  }
}

export default SharedDataExperiment;
